import config from 'config'
;(function() {
  if (!Element.prototype.addEventListener) {
    var eventListeners = []

    var addEventListener = function(type, listener) {
      var self = this
      var wrapper = function(e) {
        e.target = e.srcElement
        e.currentTarget = self
        if (typeof listener.handleEvent !== 'undefined') {
          listener.handleEvent(e)
        } else {
          listener.call(self, e)
        }
      }

      if (type === 'DOMContentLoaded') {
        var wrapper2 = function(e) {
          if (document.readyState === 'complete') {
            wrapper(e)
          }
        }
        document.attachEvent('onreadystatechange', wrapper2)
        eventListeners.push({ object: this, type: type, listener: listener, wrapper: wrapper2 })

        if (document.readyState === 'complete') {
          var e = new Event()
          e.srcElement = window
          wrapper2(e)
        }
      } else {
        this.attachEvent('on' + type, wrapper)
        eventListeners.push({ object: this, type: type, listener: listener, wrapper: wrapper })
      }
    }

    Element.prototype.addEventListener = addEventListener
    if (HTMLDocument) {
      HTMLDocument.prototype.addEventListener = addEventListener
    }

    if (Window) {
      Window.prototype.addEventListener = addEventListener
    }
  }
})()

export const MonnifySDK = (function() {
  var CONSTANT = {
    StageId: 'MonnifyFrame',
    StageName: 'MonnifyFrame',
    PaymentFormName: 'MonnifyPaymentForm',
    StyleId: 'MonnifyStyles',
    PreLoaderId: 'MonnifyPreLoader',

    LoadedMessageType: 'MonnifyPopupLoaded',
    ClosePopupMessageType: 'MonnifyPopupClose',
    TransactionCompletedMessageType: 'MonnifyPopupComplete',
  }

  var TEST_CONFIGURATIONS = {
    APP_URL: config.SDK_URL,
    BASE_API_URL: '',
    API_VERSION: '',
    APP_ORIGIN: config.SDK_URL,
  }

  var LIVE_CONFIGURATIONS = {
    APP_URL: 'http://monnifysdk.development.teamapt.com',
    BASE_API_URL: '',
    API_VERSION: '',
    APP_ORIGIN: 'http://monnifysdk.development.teamapt.com',
  }

  var CONFIGURATIONS = TEST_CONFIGURATIONS

  var paymentData = {
    amount: 0,
    merchantId: '',
    currency: 'NGN',
    reference: '',
    customerFullName: '',
    customerEmail: '',
    customerMobileNumber: '',
    paymentDescription: '',

    apiKey: '',
    contractCode: '',
    metadata: {},
    incomeSplitConfig: [],

    callback: undefined,
    onClose: undefined,
  }

  var stageData = {
    stageDOM: null,
    preLoader: null,
  }

  var initializeSDK = function(paymentParam) {
    setPaymentParam(paymentParam)

    if (!validatePaymentData()) {
      return
    }

    setupStyles()

    setupLoader()
    setupStage()
    setupPaymentForm()

    show(stageData.preLoader)
    addMessageListener()

    var form = document.forms[CONSTANT.PaymentFormName]
    if (form) {
      form.submit()
    }
  }

  var validatePaymentData = function() {
    if (!paymentData) {
      console.error('Monnify: Invalid Payment Data.')
      return false
    }

    var valid = true

    if (!paymentData.customerEmail || !isValidEmail(paymentData.customerEmail)) {
      valid = false
      console.error('Monnify: Invalid Customer Email.')
    }

    if (!paymentData.amount || !isNumeric(paymentData.amount)) {
      valid = false
      console.error('Monnify: Invalid Amount.')
    }

    if (!paymentData.contractCode) {
      valid = false
      console.error('Monnify: Invalid Contract Code')
    }

    if (!paymentData.apiKey) {
      valid = false
      console.error('Monnify: Invalid API Key')
    }

    if (paymentData.onClose && !isFunction(paymentData.onClose)) {
      valid = false
      console.error('Monnify: Invalid onClose function.')
    }

    if (paymentData.callback && !isFunction(paymentData.callback)) {
      valid = false
      console.error('Monnify: Invalid callback function.')
    }

    if (paymentData.metadata && !isObject(paymentData.metadata)) {
      valid = false
      console.error('Monnify: Invalid metadata.')
    }

    return valid
  }

  var isValidEmail = function(value) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value,
    )
  }

  var isObject = function(value) {
    return value === Object(value) && '[object Array]' !== Object.prototype.toString.call(value)
  }

  var isArray = function(value) {
    return value.constructor === Array
  }

  var isInteger = function(value) {
    return parseInt(value) == value && 0 <= value
  }

  var isNumeric = function(value) {
    return !isNaN(parseFloat(value)) && isFinite(value)
  }

  var isFunction = function(value) {
    if (!value) {
      return false
    }

    return value && '[object Function]' === {}.toString.call(value)
  }

  var setPaymentParam = function(paymentParam) {
    if (!paymentParam) {
      return
    }

    for (var prop in paymentData) {
      var param = paymentParam[prop]

      if (param) {
        paymentData[prop] = param

        if (prop === 'callback' || prop === 'onClose') {
          paymentData[prop] = parseFunction(param)
        }
      }
    }
  }

  var setupStage = function() {
    var existingStage = document.getElementById(CONSTANT.StageId)

    if (existingStage) {
      stageData.stageDOM = existingStage
      return
    }

    var bodyDOM = document.body
    var stageFrame = document.createElement('iframe')
    stageFrame.id = CONSTANT.StageId
    stageFrame.name = CONSTANT.StageName
    stageFrame.className = 'hide'

    bodyDOM.appendChild(stageFrame)
    stageData.stageDOM = document.getElementById(CONSTANT.StageId)
  }

  var setupStyles = function() {
    var styles = `#MonnifyFrame,#MonnifyPreLoader{position:fixed;top:0;left:0;width:100%;height:100%;z-index:2147483647;margin:0;padding:0;border:none;outline:0}.hide{display:none;visibility:hidden}.show{display:block;visibility:visible}#MonnifyPreLoader{background:rgba(53,53,53,.92);text-align:center;transition-property:visibility,display;transition-duration:.2s;transition-timing-function:ease-in-out}#MonnifyPreLoader .lds-spinner{top:50%;margin-top:-40px}.lds-spinner{color:#005F7D;display:inline-block;position:relative;width:64px;height:64px}.lds-spinner div{transform-origin:32px 32px;animation:lds-spinner 1.2s linear infinite}.lds-spinner div:after{content:" ";display:block;position:absolute;top:3px;left:29px;width:5px;height:14px;border-radius:20%;background:#005F7D}.lds-spinner div:nth-child(1){transform:rotate(0);animation-delay:-1.1s}.lds-spinner div:nth-child(2){transform:rotate(30deg);animation-delay:-1s}.lds-spinner div:nth-child(3){transform:rotate(60deg);animation-delay:-.9s}.lds-spinner div:nth-child(4){transform:rotate(90deg);animation-delay:-.8s}.lds-spinner div:nth-child(5){transform:rotate(120deg);animation-delay:-.7s}.lds-spinner div:nth-child(6){transform:rotate(150deg);animation-delay:-.6s}.lds-spinner div:nth-child(7){transform:rotate(180deg);animation-delay:-.5s}.lds-spinner div:nth-child(8){transform:rotate(210deg);animation-delay:-.4s}.lds-spinner div:nth-child(9){transform:rotate(240deg);animation-delay:-.3s}.lds-spinner div:nth-child(10){transform:rotate(270deg);animation-delay:-.2s}.lds-spinner div:nth-child(11){transform:rotate(300deg);animation-delay:-.1s}.lds-spinner div:nth-child(12){transform:rotate(330deg);animation-delay:0s}@keyframes lds-spinner{0%{opacity:1}100%{opacity:0}}`

    var head = document.head || document.getElementsByTagName('head')[0]
    var styleElement = document.createElement('style')

    styleElement.type = 'text/css'
    styleElement.id = CONSTANT.StyleId

    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = styles
      styleElement.styleSheet.insertRule(styles, 0)
    } else {
      styleElement.appendChild(document.createTextNode(styles))
    }

    head.appendChild(styleElement)
  }

  var setupPaymentForm = function() {
    if (!stageData.stageDOM) {
      return
    }

    var existingPaymentForms = document.getElementsByName(CONSTANT.PaymentFormName)
    if (existingPaymentForms && existingPaymentForms.length > 0) {
      try {
        existingPaymentForms = existingPaymentForms[0]
        existingPaymentForms.parentNode.removeChild(existingPaymentForms)
      } catch (e) {
        console.error('Monnify: Error occurred while removing existing payment form' + e)
      }
    }

    var form = `<form name="${CONSTANT.PaymentFormName}" id="${CONSTANT.PaymentFormName}" action='${
      CONFIGURATIONS.APP_URL
    }' method="post" 
                          enctype="application/x-www-form-urlencoded" target="${CONSTANT.StageId}">
                        <input type="hidden" name="merchantId" value="${paymentData.merchantId}"/>
                        <input type="hidden" name="amount" value="${paymentData.amount}" />
                        <input type="hidden" name="sourceUrl" value="${fetchSourceUrl()}"/>
                        <input type="hidden" name="currency" value="${paymentData.currency}"/>
                        <input type="hidden" name="paymentReference" value="${
                          paymentData.reference
                        }"/>
                        <input type="hidden" name="customerFullName" value="${
                          paymentData.customerFullName
                        }"/>
                        <input type="hidden" name="customerEmail" value="${
                          paymentData.customerEmail
                        }"/>
                        <input type="hidden" name="customerMobileNumber" value="${
                          paymentData.customerMobileNumber
                        }"/>
                        <input type="hidden" name="paymentDescription" value="${
                          paymentData.paymentDescription
                        }"/>
                        <input type="hidden" name="metadata" value="${JSON.stringify(
                          paymentData.metadata,
                        )}"/>
                        <input type="hidden" name="incomeSplitConfig" value="${JSON.stringify(
                          paymentData.incomeSplitConfig,
                        )}"/>

                        <input type="hidden" name="apiKey" value="${paymentData.apiKey}"/>
                        <input type="hidden" name="contractCode" value="${
                          paymentData.contractCode
                        }"/>
                    </form>`

    document.body.insertAdjacentHTML('beforeend', form)
  }

  var addMessageListener = function() {
    window.addEventListener('message', function(event) {
      if (!event.source || event.source.top !== window) {
        return
      }

      if (event.origin !== CONFIGURATIONS.APP_ORIGIN) {
        return
      }

      var key = event.message ? 'message' : 'data'
      var eventData = event[key]
      if (!eventData) {
        return
      }

      eventData = JSON.parse(eventData)

      switch (eventData.type) {
        case CONSTANT.LoadedMessageType: {
          handlePopupLoadedMessage()
          break
        }
        case CONSTANT.ClosePopupMessageType: {
          handleClosePopupMessage(eventData.message)
          break
        }
        case CONSTANT.TransactionCompletedMessageType: {
          handleTransactionCompleteMessage(eventData.message)
          break
        }
      }
    })
  }

  var handlePopupLoadedMessage = function() {
    show(stageData.stageDOM)
    hide(stageData.preLoader)
  }

  var handleClosePopupMessage = function(message) {
    callFunction(paymentData.onClose, message)

    if (message.redirectUrl && message.redirectUrl !== fetchSourceUrl()) {
      window.location.href = message.redirectUrl
    }

    closeStage()
  }

  var handleTransactionCompleteMessage = function(message) {
    callFunction(paymentData.callback, message)
  }

  var parseFunction = function(fnString) {
    if (!fnString) {
      return fnString
    }

    try {
      var fn

      if (typeof fnString === 'function') {
        fn = fnString
      } else {
        fn = eval(fnString)
      }

      return fn
    } catch (e) {
      return fnString
    }
  }

  var callFunction = function(fn, params) {
    if (!fn) {
      return
    }

    fn(params)
  }

  var setupLoader = function() {
    var existingLoader = document.getElementById(CONSTANT.PreLoaderId)
    if (existingLoader) {
      stageData.preLoader = existingLoader
      return
    }

    var loaderDom = `<div class="${CONSTANT.PreLoaderId} hide" id="${
      CONSTANT.PreLoaderId
    }"><div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>`
    var bodyDom = document.body

    bodyDom.insertAdjacentHTML('beforeend', loaderDom)
    stageData.preLoader = document.getElementById(CONSTANT.PreLoaderId)
  }

  var closeStage = function() {
    if (!stageData.stageDOM) {
      return
    }

    var paymentForm = document.forms[CONSTANT.PaymentFormName]
    if (paymentForm) {
      paymentForm.parentNode.removeChild(paymentForm)
    }

    hide(stageData.stageDOM)
    clearStage()
  }

  var clearStage = function() {
    if (!stageData.stageDOM) {
      return
    }

    stageData.stageDOM.src = 'about:blank'
  }

  var hide = function(element) {
    element.className = element.className.replace(/(?:^|\s)show(?!\S)/g, '')
    if (!element.className.match(/(?:^|\s)hide(?!\S)/g)) {
      element.className += ' hide'
    }
  }

  var show = function(element) {
    element.className = element.className.replace(/(?:^|\s)hide(?!\S)/g, '')
    if (!element.className.match(/(?:^|\s)hide(?!\S)/g)) {
      element.className += ' show'
    }
  }

  var bindAction = function(element) {
    if (!element) {
      return
    }

    element.addEventListener('click', function(event) {
      var target = event.target
      var amount = target.getAttribute('data-monnify-amount')
      var merchantId = target.getAttribute('data-monnify-merchant-id')
      var reference = target.getAttribute('data-monnify-reference')
      var paymentDescription = target.getAttribute('data-monnify-payment-description')
      var currency = target.getAttribute('data-monnify-currency')
      var apiKey = target.getAttribute('data-monnify-api-key')
      var customerFullName = target.getAttribute('data-monnify-customer-full-name')
      var customerEmail = target.getAttribute('data-monnify-customer-email')
      var customerMobileNumber = target.getAttribute('data-monnify-customer-mobile-number')
      var contractCode = target.getAttribute('data-monnify-contract-code')

      var completeCallback = target.getAttribute('data-monnify-callback')

      var paymentParam = {
        amount: amount,
        merchantId: merchantId,
        reference: reference,
        currency: currency,
        apiKey: apiKey,
        customerFullName: customerFullName,
        customerMobileNumber: customerMobileNumber,
        customerEmail: customerEmail,
        contractCode: contractCode,
        paymentDescription: paymentDescription,
      }

      initializeSDK(paymentParam, completeCallback)
    })
  }

  var fetchSourceUrl = function() {
    return document.location.href
  }

  var bootstrap = function() {
    var buttons = document.getElementsByClassName('monnify-payment-buttons')
    if (buttons && buttons.length < 1) {
      return
    }

    for (var i = 0; i < buttons.length; i++) {
      var payButton = buttons[i]
      bindAction(payButton)
    }
  }

  return {
    bootstrap: bootstrap,
    initialize: initializeSDK,
  }
})()



// WEBPACK FOOTER //
// ./src/modules/MonnifySDK/monnify.js